import {useNavigate} from "react-router-dom";
import {Button, Col, Input, Row, Space, Spin, Typography} from "antd";
import {useEffect, useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import AttendanceTable from "./AttendanceTable";
import {  useDeleteQuery, useGetQuery} from "../../service/query/Queries";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {BiRefresh} from "react-icons/bi";
const {Title}=Typography

const Office = () => {

    const {data,isLoading:getLoading,refetch}=useGetQuery(true,'employee-get',`/faceid` , false,5*60*1000);
    const [search, setSearch] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const ScreenMD = useBreakpoint().md;


    // delete

    useEffect(() => {
        refetch()
    }, []);

    // add

    const searchFunc = (value) => {
        if (value === '') {
            setIsSearch(false);
        } else {
            setIsSearch(true);
        }
        const filterData = data?.filter(
            (data) => data?.user_name.toLowerCase().includes(value.toLowerCase()));
        setSearch(filterData);
    };

    return (
        <div className={'site-space-compact-wrapper'}>
            <Space direction={'vertical'} size={"large"} style={{width: '100%'}}>
                <Row gutter={[10 , 20]}>
                    <Col span={18}>
                        <Title className={'page--title'} level={2}>
                            Офис
                        </Title>
                    </Col>
                    {/*<FilterCompanyForAdmin/>*/}
                    <Col span={ 16 }>
                        <Input placeholder="Поиск сотрудник" onChange={(e) => searchFunc(e.target.value)} />
                    </Col>

                    <Col span={8}>
                        <Button
                            type=''
                            icon={<BiRefresh style={{width:"30px",height:"30px"}}/>}
                            style={{width: '100%'}}
                            onClick={refetch}>

                        </Button>
                    </Col>

                </Row>
                <Spin
                    size='medium'
                    spinning={getLoading }>
                    <AttendanceTable
                        data={isSearch ? search : data}
                    />
                </Spin>
            </Space>
        </div>
    );
};

export default Office;